import { render, staticRenderFns } from "./CadastroOfertaVariacaoDimensao.vue?vue&type=template&id=49d602a2"
import script from "./CadastroOfertaVariacaoDimensao.vue?vue&type=script&lang=js"
export * from "./CadastroOfertaVariacaoDimensao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports